import {
  REQUEST_SECURE_URL_LOADING,
  REQUEST_SECURE_URL_SUCCESS,
  REQUEST_SECURE_URL_FAILURE,
} from "redux/types";

const initialState = {
  requestSecureUrlLoading: false,
  requestSecureUrlData: null,
  errors: null,
};

export const requestSecureUrlReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case REQUEST_SECURE_URL_LOADING:
      return { ...state, requestSecureUrlLoading: action.payload };
    case REQUEST_SECURE_URL_SUCCESS:
      return { ...state, requestSecureUrlData: action.payload };
    case REQUEST_SECURE_URL_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
